import {registerJQueryComponent} from '@lib/JQueryRegistry'

export default class LoginFormField {
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            status: rootElement.find('.login-form-field-status'),
            parent: $('.login-form-wrapper')
        }

        this.$state = {
            isInputFilled: false,
        }

        this.$dom.root.keyup(this.onKeyUp)
    }


    validate = () => {
        if (this.isValid()) {
            this.$dom.status.removeClass('invalid').addClass('valid')
        } else {
            this.$dom.status.removeClass('valid').addClass('invalid')
        }
    }
}